import {EffectCallback, useEffect, useRef} from 'react';

export function useMount(effect: EffectCallback): void {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;

    effect();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
